import { render, staticRenderFns } from "./AdminExpirations.vue?vue&type=template&id=34915610&"
import script from "./AdminExpirations.vue?vue&type=script&lang=js&"
export * from "./AdminExpirations.vue?vue&type=script&lang=js&"
import style0 from "./AdminExpirations.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminExpirations.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./AdminExpirations.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports